var AddToCartType = /* @__PURE__ */ ((AddToCartType2) => {
  AddToCartType2["ADDTOCART"] = "addToCart";
  AddToCartType2["BUYNOW"] = "buy_now";
  return AddToCartType2;
})(AddToCartType || {});

export { AddToCartType };
